const FaxTrackerApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/fax-tracker/get`,
  SAVE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/fax-tracker/createFaxManifest`,
  DELETE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/fax-tracker/delete`,
};

export default FaxTrackerApiUrls
